import { render, staticRenderFns } from "./MLogin.vue?vue&type=template&id=fcdab260&scoped=true&"
import script from "./MLogin.vue?vue&type=script&lang=ts&"
export * from "./MLogin.vue?vue&type=script&lang=ts&"
import style0 from "./MLogin.vue?vue&type=style&index=0&id=fcdab260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcdab260",
  null
  
)

export default component.exports